export const GET_ALL_SUBS_PACKAGE = "GET_ALL_SUBS_PACKAGE";
export const GET_ALL_SUBS_PACKAGE_SUCCESS = "GET_ALL_SUBS_PACKAGE_SUCCESS";
export const GET_ALL_SUBS_PACKAGE_FAILED = "GET_ALL_SUBS_PACKAGE_FAILED";